export const starShine = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 0.5L7.74097 5.75903L13 7L7.74097 8.24097L6.5 13.5L5.25903 8.24097L0 7L5.25903 5.75903L6.5 0.5Z" fill="#99F1FF"/>
</svg>`;
